import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=6428c8d2&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=6428c8d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6428c8d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6428c8d2')) {
      api.createRecord('6428c8d2', component.options)
    } else {
      api.reload('6428c8d2', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=6428c8d2&scoped=true&", function () {
      api.rerender('6428c8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lib/loading.vue"
export default component.exports